import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import conso from '%/conso';
import ax, { CONTROL_CONTACT, VERIFY_RECAPTCHA } from '%/axios';
import * as yup from 'yup';
import { Formik } from 'formik';
import ReCAPTCHA from "react-google-recaptcha";

const schema = yup.object().shape({
  name: yup.string().required(),
  Email: yup.string().required(),
  Content: yup.string().required(),
  rma_number: yup.string(),
  City: yup.string(),
  State: yup.string(),
  'Order-Number': yup.string()

});

function ContactUsForm() {

  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const verifyToken = async (token) => {
    try {
      const res = await ax(VERIFY_RECAPTCHA, { token });
      return res?.success;
    } catch (er) {
      conso.trace(er);
      throw new Error();

    }
  }

  const submitForm = async (data, form) => {
    try {

      const verified = verifyToken();
      if (!verified) return setError('Recaptcha is invalid.');
      const res = await ax(CONTROL_CONTACT, {
        data,
        control: 'make'
      });
      if (res) {
        setSuccess(true);
        window.location.href = '/contact-confirmation';
      }

    } catch (er) {
      conso.trace(er);

    }

  }
  useEffect(() => {
    if (success) {
      const A = setTimeout(() => {
        setSuccess(false)
      }, 7000);

      return () => clearTimeout(A);
    }

  }, [success])


  return (
    <Formik
      validationSchema={schema}
      initialValues={{
        name: '',
        Content: '',

      }}
      onSubmit={submitForm}
    >
      {({ values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting, }) =>

        <form id="email-form" name="email-form"
          onSubmit={handleSubmit}
          data-name="Email Form" method="get" class="contact-form">
          <div class="contact-form-wrapper">
            <input type="text"
              value={values.name}
              onChange={handleChange}
              class="contact-text-field half w-input" maxlength="256" name="name"
              placeholder="Full Name*" />
            <input type="tel"
              value={values['Phone-Number']}
              onChange={handleChange}
              class="contact-text-field half w-input" maxlength="256" name="Phone-Number" data-name="Phone Number"
              placeholder="Phone Number*" id="Phone-Number" required="" />
          </div>
          <input
            value={values['Company-Name']}
            onChange={handleChange}
            type="text" class="contact-text-field w-input"
            maxlength="256" name="Company-Name" data-name="Agency" placeholder="Agency*" id="Agency-3" required="" />

          <div class="contact-form-wrapper">
            <input
              value={values.City}
              onChange={handleChange}
              type="text" class="contact-text-field half w-input" maxlength="256"
              name="City" data-name="Agency City" placeholder="City*" id="Agency-City" required="" />
            <input
              value={values.State}
              onChange={handleChange}
              type="text" class="contact-text-field half w-input" maxlength="256" name="State"
              data-name="state" placeholder="State*" id="State" required="" /></div>
          <input type="email"
            value={values.Email}
            onChange={handleChange}
            class="contact-text-field w-input" maxlength="256" name="Email"
            placeholder="Enter your e-mail*" id="Email-3" />
          <input type="text"
            value={values['Order-Number']}
            onChange={handleChange}
            class="contact-text-field w-input" maxlength="256" name="Order-Number"
            placeholder="Order Number*" />
          <textarea
            value={values.Content}
            onChange={handleChange}
            placeholder="How can we help you today?*"
            maxlength="5000" id="field" name="Content" required=""
            class="contact-field-text-area w-input"></textarea>
          {
            Object.values(errors).length > 0 &&

            Object.values(errors).map(each =>
              <div class="w-form-fail" style={{ display: 'block' }}>
                <div>{each}</div>
              </div>
            )
          }
          <ReCAPTCHA
            sitekey="6LfUY8clAAAAAEJBofevY7k63tePIyIea0cHFd6h"
            onChange={verifyToken}
          />

          <input
            style={{
              marginTop: 18
            }}
            type="submit" value="Send Message Now" data-wait="Please wait..." class="login-submit-button w-button" />

          {success &&
            <div class="w-form-done" style={{ display: 'block', marginTop: 12 }}>
              <div>Thank you! Your submission has been received!</div>
            </div>

          }
        </form>
      }
    </Formik>
  );
}

export default ContactUsForm;

ReactDOM.render(<ContactUsForm />, document.getElementById('contact-us'));
